import { Injectable } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import * as R from 'ramda'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { isSomething, UserStorage } from '@tokeet-frontend/tv3-platform'
import { FilterGroup } from '@tv3/services/utils/filters.service'
import { FilterFormGroup } from '@tokeet-frontend/tv3-platform'
import { ContractTemplateView, selectContractTemplateViews } from '@tokeet-frontend/signature'
import { tagsIntersection } from '@tokeet-frontend/tags'

@Injectable()
export class DocumentTemplateFilters {
  defaultValues = {
    type: [],
    tags: [],
    search: '',
  }

  filters = {
    type: (items: ContractTemplateView[], types: string[]) => {
      if (!isSomething(types)) return items

      return R.filter((e: ContractTemplateView) => R.contains(e.type, types), items)
    },
    tags: (items: ContractTemplateView[], tags: string[]) => {
      if (!isSomething(tags)) return items
      return R.filter(
        (e: ContractTemplateView) => tagsIntersection(e.attributes?.tags || [], tags || [])?.length > 0,
        items
      )
    },
  }

  group: FilterFormGroup<ContractTemplateView>

  constructor(private store: Store<fromRoot.State>, private fb: FormBuilder, private storage: UserStorage) {
    const storedFilters = this.storage.get(FilterGroup.Extra, this.defaultValues)

    const group = this.fb.group({
      type: [storedFilters.type],
      tags: [storedFilters.tags],
      search: [storedFilters.search],
    })

    this.group = new FilterFormGroup<ContractTemplateView>(
      group.controls,
      this.store,
      this.storage,
      FilterGroup.Extra,
      selectContractTemplateViews,
      this.filters
    )
  }
}
